import { fetchGet, toQueryString } from "../../../../service/api_client";

export const GetProjectListApi = async (param: {
  page: number;
  count: number;
  all?: any;
}) => {
  try {
    const url = `${
      process.env.REACT_APP_BACKEND_BASE_URL
    }/api/v3/erp/inventory/project${toQueryString(param)}`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
